import VrrTag from './VrrTag';

export default VrrTag;
